"use strict";

import get from "lodash/get";

// Utils
import { LocalStoreManager } from "@sleek/customer-common-acquisition";

import { KEYS } from "./constants";

export const getStorage = () => {
  if (sessionStorage) return sessionStorage;

  return localStorage;
};

export const storeUserProfile = async (profile) => {
  try {
    const localStore = new LocalStoreManager();
    await localStore.storeProfile(null, profile, false);
  } catch (error) {
    console.error(error);
  }
};

export const setSbaToken = (response) => {
  const sbaToken = get(response, "data.metadata.sba_token");
  if (sbaToken) {
    const localStore = new LocalStoreManager();
    localStore.setBusinessAccountToken(sbaToken);
    localStore.enableSbaSkip2faFirstAttempt();
  }
};

export const setAuthKey = (value) => {
  const storage = getStorage();
  return storage.setItem(KEYS.AUTH_KEY, value);
};
